import '../assets/NcMentionBubble-7PQ8wEko.css';
import '../assets/NcAvatar-BozWHt1s.css';
import { N as v } from "./NcActions-DiFslXqv.mjs";
import S from "../Components/NcActionLink.mjs";
import g from "../Components/NcActionRouter.mjs";
import y from "../Components/NcActionText.mjs";
import U from "../Components/NcButton.mjs";
import { N } from "./NcIconSvgWrapper-BTdzvQGV.mjs";
import _ from "../Components/NcLoadingIcon.mjs";
import { N as A, g as M } from "./NcUserStatusIcon-HOUdT_MR.mjs";
import { u as l } from "./usernameToColor-BHkzj1tb.mjs";
import { g as x } from "./getAvatarUrl-BHpn8LgJ.mjs";
import "../Composables/useIsFullscreen.mjs";
import "../Composables/useIsMobile.mjs";
/* empty css                                                                          */
import { n as L } from "./_plugin-vue2_normalizer-Bj5bLKV4.mjs";
import "linkify-string";
import "escape-html";
import "striptags";
import "vue";
import { getCurrentUser as u } from "@nextcloud/auth";
import d from "@nextcloud/axios";
import { getCapabilities as b } from "@nextcloud/capabilities";
import { generateOcsUrl as w, generateUrl as C } from "@nextcloud/router";
import { r as I, n as D, a as r } from "./_l10n-BaNxGGXy.mjs";
import { g as O } from "./autolink-DNGB8YSW.mjs";
import { D as k } from "./DotsHorizontal-DfVgEXgz.mjs";
import { subscribe as n, unsubscribe as o } from "@nextcloud/event-bus";
import { getBuilder as B } from "@nextcloud/browser-storage";
import { vOnClickOutside as E } from "@vueuse/components";
/**
 * @copyright Copyright (c) 2020 Georg Ehrke <georg-nextcloud@ehrke.email>
 *
 * @author Georg Ehrke <georg-nextcloud@ehrke.email>
 *
 * @license AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
const z = {
  data() {
    return {
      hasStatus: !1,
      userStatus: {
        status: null,
        message: null,
        icon: null
      }
    };
  },
  methods: {
    /**
     * Fetches the user-status from the server
     *
     * @param {string} userId UserId of the user to fetch the status for
     *
     * @return {Promise<void>}
     */
    async fetchUserStatus(s) {
      var e, a;
      if (!s)
        return;
      const t = b();
      if (!(!Object.prototype.hasOwnProperty.call(t, "user_status") || !t.user_status.enabled) && u())
        try {
          const { data: i } = await d.get(w("apps/user_status/api/v1/statuses/{userId}", { userId: s })), {
            status: p,
            message: f,
            icon: m
          } = i.ocs.data;
          this.userStatus.status = p, this.userStatus.message = f || "", this.userStatus.icon = m || "", this.hasStatus = !0;
        } catch (i) {
          if (i.response.status === 404 && ((a = (e = i.response.data.ocs) == null ? void 0 : e.data) == null ? void 0 : a.length) === 0)
            return;
          console.error(i);
        }
    }
  }
};
I(D);
const h = B("nextcloud").persist().build();
function $(s) {
  const t = h.getItem("user-has-avatar." + s);
  return typeof t == "string" ? !!t : null;
}
function c(s, t) {
  s && h.setItem("user-has-avatar." + s, t);
}
const P = {
  name: "NcAvatar",
  directives: {
    ClickOutside: E
  },
  components: {
    DotsHorizontal: k,
    NcActions: v,
    NcButton: U,
    NcIconSvgWrapper: N,
    NcLoadingIcon: _,
    NcUserStatusIcon: A
  },
  mixins: [z],
  props: {
    /**
     * Set a custom url to the avatar image
     * either the url, user or displayName property must be defined
     */
    url: {
      type: String,
      default: void 0
    },
    /**
     * Set a css icon-class for an icon to be used instead of the avatar.
     */
    iconClass: {
      type: String,
      default: void 0
    },
    /**
     * Set the user id to fetch the avatar
     * either the url, user or displayName property must be defined
     */
    user: {
      type: String,
      default: void 0
    },
    /**
     * Whether or not to display the user-status
     */
    showUserStatus: {
      type: Boolean,
      default: !0
    },
    /**
     * Whether or not to the status-icon should be used instead of online/away
     */
    showUserStatusCompact: {
      type: Boolean,
      default: !0
    },
    /**
     * When the user status was preloaded via another source it can be handed in with this property to save the request.
     * If this property is not set the status will be fetched automatically.
     * If a preloaded no-status is available provide this object with properties "status", "icon" and "message" set to null.
     */
    preloadedUserStatus: {
      type: Object,
      default: void 0
    },
    /**
     * Is the user a guest user (then we have to user a different endpoint)
     */
    isGuest: {
      type: Boolean,
      default: !1
    },
    /**
     * Set a display name that will be rendered as a tooltip
     * either the url, user or displayName property must be defined
     * specify just the displayname to generate a placeholder avatar without
     * trying to fetch the avatar based on the user id
     */
    displayName: {
      type: String,
      default: void 0
    },
    /**
     * Set a size in px for the rendered avatar
     */
    size: {
      type: Number,
      default: 32
    },
    /**
     * Placeholder avatars will be automatically generated when this is set to true
     */
    allowPlaceholder: {
      type: Boolean,
      default: !0
    },
    /**
     * Disable the tooltip
     */
    disableTooltip: {
      type: Boolean,
      default: !1
    },
    /**
     * Disable the menu
     */
    disableMenu: {
      type: Boolean,
      default: !1
    },
    /**
     * Declares a custom tooltip when not null
     * Fallback will be the displayName
     *
     * requires disableTooltip not to be set to true
     */
    tooltipMessage: {
      type: String,
      default: null
    },
    /**
     * Declares username is not a user's name, when true.
     * Prevents loading user's avatar from server and forces generating colored initials,
     * i.e. if the user is a group
     */
    isNoUser: {
      type: Boolean,
      default: !1
    },
    /**
     * Selector for the popover menu container
     */
    menuContainer: {
      type: [String, Object, Element, Boolean],
      default: "body"
    }
  },
  data() {
    return {
      avatarUrlLoaded: null,
      avatarSrcSetLoaded: null,
      userDoesNotExist: !1,
      isAvatarLoaded: !1,
      isMenuLoaded: !1,
      contactsMenuLoading: !1,
      contactsMenuActions: [],
      contactsMenuOpenState: !1
    };
  },
  computed: {
    avatarAriaLabel() {
      var s, t;
      if (this.hasMenu)
        return this.canDisplayUserStatus || this.showUserStatusIconOnAvatar ? r("Avatar of {displayName}, {status}", { displayName: (s = this.displayName) != null ? s : this.user, status: M(this.userStatus.status) }) : r("Avatar of {displayName}", { displayName: (t = this.displayName) != null ? t : this.user });
    },
    canDisplayUserStatus() {
      return this.showUserStatus && this.hasStatus && ["online", "away", "busy", "dnd"].includes(this.userStatus.status);
    },
    showUserStatusIconOnAvatar() {
      return this.showUserStatus && this.showUserStatusCompact && this.hasStatus && this.userStatus.status !== "dnd" && this.userStatus.icon;
    },
    /**
     * The user identifier, either the display name if set or the user property
     * If both properties are not set an empty string is returned
     */
    userIdentifier() {
      return this.isDisplayNameDefined ? this.displayName : this.isUserDefined ? this.user : "";
    },
    isUserDefined() {
      return typeof this.user < "u";
    },
    isDisplayNameDefined() {
      return typeof this.displayName < "u";
    },
    isUrlDefined() {
      return typeof this.url < "u";
    },
    hasMenu() {
      var s;
      return this.disableMenu ? !1 : this.isMenuLoaded ? this.menu.length > 0 : !(this.user === ((s = u()) == null ? void 0 : s.uid) || this.userDoesNotExist || this.url);
    },
    /**
     * True if initials should be shown as the user icon fallback
     */
    showInitials() {
      return this.allowPlaceholder && this.userDoesNotExist && !(this.iconClass || this.$slots.icon);
    },
    avatarStyle() {
      return {
        "--size": this.size + "px",
        lineHeight: this.size + "px",
        fontSize: Math.round(this.size * 0.45) + "px"
      };
    },
    initialsWrapperStyle() {
      const { r: s, g: t, b: e } = l(this.userIdentifier);
      return {
        backgroundColor: "rgba(".concat(s, ", ").concat(t, ", ").concat(e, ", 0.1)")
      };
    },
    initialsStyle() {
      const { r: s, g: t, b: e } = l(this.userIdentifier);
      return {
        color: "rgb(".concat(s, ", ").concat(t, ", ").concat(e, ")")
      };
    },
    tooltip() {
      return this.disableTooltip ? !1 : this.tooltipMessage ? this.tooltipMessage : this.displayName;
    },
    /**
     * Get the (max. two) initials of the user as uppcase string
     */
    initials() {
      let s = "?";
      if (this.showInitials) {
        const t = this.userIdentifier.trim();
        if (t === "")
          return s;
        const e = t.match(/[\p{L}\p{N}\s]/gu);
        if (e == null)
          return s;
        const a = e.join(""), i = a.lastIndexOf(" ");
        s = String.fromCodePoint(a.codePointAt(0)), i !== -1 && (s = s.concat(String.fromCodePoint(a.codePointAt(i + 1))));
      }
      return s.toLocaleUpperCase();
    },
    menu() {
      const s = this.contactsMenuActions.map((e) => {
        const a = O(this.$router, e.hyperlink);
        return {
          ncActionComponent: a ? g : S,
          ncActionComponentProps: a ? {
            to: a,
            icon: e.icon
          } : {
            href: e.hyperlink,
            icon: e.icon
          },
          text: e.title
        };
      });
      function t(e) {
        const a = document.createTextNode(e), i = document.createElement("p");
        return i.appendChild(a), i.innerHTML;
      }
      if (this.showUserStatus && (this.userStatus.icon || this.userStatus.message)) {
        const e = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">\n					<text x="50%" y="50%" text-anchor="middle" style="dominant-baseline: central; font-size: 85%">'.concat(t(this.userStatus.icon), "</text>\n				</svg>");
        return [{
          ncActionComponent: y,
          ncActionComponentProps: {},
          iconSvg: this.userStatus.icon ? e : void 0,
          text: "".concat(this.userStatus.message)
        }].concat(s);
      }
      return s;
    }
  },
  watch: {
    url() {
      this.userDoesNotExist = !1, this.loadAvatarUrl();
    },
    user() {
      this.userDoesNotExist = !1, this.isMenuLoaded = !1, this.loadAvatarUrl();
    }
  },
  mounted() {
    this.loadAvatarUrl(), n("settings:avatar:updated", this.loadAvatarUrl), n("settings:display-name:updated", this.loadAvatarUrl), this.showUserStatus && this.user && !this.isNoUser && (this.preloadedUserStatus ? (this.userStatus.status = this.preloadedUserStatus.status || "", this.userStatus.message = this.preloadedUserStatus.message || "", this.userStatus.icon = this.preloadedUserStatus.icon || "", this.hasStatus = this.preloadedUserStatus.status !== null) : this.fetchUserStatus(this.user), n("user_status:status.updated", this.handleUserStatusUpdated));
  },
  beforeDestroy() {
    o("settings:avatar:updated", this.loadAvatarUrl), o("settings:display-name:updated", this.loadAvatarUrl), this.showUserStatus && this.user && !this.isNoUser && o("user_status:status.updated", this.handleUserStatusUpdated);
  },
  methods: {
    t: r,
    handleUserStatusUpdated(s) {
      this.user === s.userId && (this.userStatus = {
        status: s.status,
        icon: s.icon,
        message: s.message
      });
    },
    /**
     * Toggle the popover menu on click or enter
     * @param {KeyboardEvent|MouseEvent} event the UI event
     */
    async toggleMenu(s) {
      s.type === "keydown" && s.key !== "Enter" || (this.contactsMenuOpenState || await this.fetchContactsMenu(), this.contactsMenuOpenState = !this.contactsMenuOpenState);
    },
    closeMenu() {
      this.contactsMenuOpenState = !1;
    },
    async fetchContactsMenu() {
      this.contactsMenuLoading = !0;
      try {
        const s = encodeURIComponent(this.user), { data: t } = await d.post(C("contactsmenu/findOne"), "shareType=0&shareWith=".concat(s));
        this.contactsMenuActions = t.topAction ? [t.topAction].concat(t.actions) : t.actions;
      } catch {
        this.contactsMenuOpenState = !1;
      }
      this.contactsMenuLoading = !1, this.isMenuLoaded = !0;
    },
    /**
     * Handle avatar loading if user or url defined
     */
    loadAvatarUrl() {
      if (this.isAvatarLoaded = !1, !this.isUrlDefined && (!this.isUserDefined || this.isNoUser)) {
        this.isAvatarLoaded = !0, this.userDoesNotExist = !0;
        return;
      }
      if (this.isUrlDefined) {
        this.updateImageIfValid(this.url);
        return;
      }
      if (this.size <= 64) {
        const s = this.avatarUrlGenerator(this.user, 64), t = [
          s + " 1x",
          this.avatarUrlGenerator(this.user, 512) + " 8x"
        ].join(", ");
        this.updateImageIfValid(s, t);
      } else {
        const s = this.avatarUrlGenerator(this.user, 512);
        this.updateImageIfValid(s);
      }
    },
    /**
     * Generate an avatar url from the server's avatar endpoint
     *
     * @param {string} user the user id
     * @param {number} size the desired size
     * @return {string}
     */
    avatarUrlGenerator(s, t) {
      var a;
      let e = x(s, t, this.isGuest);
      return s === ((a = u()) == null ? void 0 : a.uid) && typeof oc_userconfig < "u" && (e += "?v=" + oc_userconfig.avatar.version), e;
    },
    /**
     * Check if the provided url is valid and update Avatar if so
     *
     * @param {string} url the avatar url
     * @param {Array} srcset the avatar srcset
     */
    updateImageIfValid(s, t = null) {
      const e = $(this.user);
      if (this.isUserDefined && typeof e == "boolean") {
        this.isAvatarLoaded = !0, this.avatarUrlLoaded = s, t && (this.avatarSrcSetLoaded = t), e === !1 && (this.userDoesNotExist = !0);
        return;
      }
      const a = new Image();
      a.onload = () => {
        this.avatarUrlLoaded = s, t && (this.avatarSrcSetLoaded = t), this.isAvatarLoaded = !0, c(this.user, !0);
      }, a.onerror = () => {
        console.debug("Invalid avatar url", s), this.avatarUrlLoaded = null, this.avatarSrcSetLoaded = null, this.userDoesNotExist = !0, this.isAvatarLoaded = !1, c(this.user, !1);
      }, t && (a.srcset = t), a.src = s;
    }
  }
};
var T = function() {
  var t = this, e = t._self._c;
  return e("span", { directives: [{ name: "click-outside", rawName: "v-click-outside", value: t.closeMenu, expression: "closeMenu" }], ref: "main", staticClass: "avatardiv popovermenu-wrapper", class: {
    "avatardiv--unknown": t.userDoesNotExist,
    "avatardiv--with-menu": t.hasMenu,
    "avatardiv--with-menu-loading": t.contactsMenuLoading
  }, style: t.avatarStyle }, [t._t("icon", function() {
    return [t.iconClass ? e("span", { staticClass: "avatar-class-icon", class: t.iconClass }) : t.isAvatarLoaded && !t.userDoesNotExist ? e("img", { attrs: { src: t.avatarUrlLoaded, srcset: t.avatarSrcSetLoaded, alt: "" } }) : t._e()];
  }), t.hasMenu && t.menu.length === 0 ? e("NcButton", { staticClass: "action-item action-item__menutoggle", attrs: { type: "tertiary-no-background", "aria-label": t.avatarAriaLabel, title: t.tooltip }, on: { click: t.toggleMenu }, scopedSlots: t._u([{ key: "icon", fn: function() {
    return [t.contactsMenuLoading ? e("NcLoadingIcon") : e("DotsHorizontal", { attrs: { size: 20 } })];
  }, proxy: !0 }], null, !1, 2617833509) }) : t.hasMenu ? e("NcActions", { attrs: { "force-menu": "", "manual-open": "", type: "tertiary-no-background", container: t.menuContainer, open: t.contactsMenuOpenState, "aria-label": t.avatarAriaLabel, title: t.tooltip }, on: { "update:open": function(a) {
    t.contactsMenuOpenState = a;
  }, click: t.toggleMenu }, scopedSlots: t._u([t.contactsMenuLoading ? { key: "icon", fn: function() {
    return [e("NcLoadingIcon")];
  }, proxy: !0 } : null], null, !0) }, t._l(t.menu, function(a, i) {
    return e(a.ncActionComponent, t._b({ key: i, tag: "component", scopedSlots: t._u([a.iconSvg ? { key: "icon", fn: function() {
      return [e("NcIconSvgWrapper", { attrs: { svg: a.iconSvg } })];
    }, proxy: !0 } : null], null, !0) }, "component", a.ncActionComponentProps, !1), [t._v(" " + t._s(a.text) + " ")]);
  }), 1) : t._e(), t.showUserStatusIconOnAvatar ? e("span", { staticClass: "avatardiv__user-status avatardiv__user-status--icon" }, [t._v(" " + t._s(t.userStatus.icon) + " ")]) : t.canDisplayUserStatus ? e("NcUserStatusIcon", { staticClass: "avatardiv__user-status", attrs: { status: t.userStatus.status, "aria-hidden": String(t.hasMenu) } }) : t._e(), t.showInitials ? e("span", { staticClass: "avatardiv__initials-wrapper", style: t.initialsWrapperStyle }, [e("span", { staticClass: "avatardiv__initials", style: t.initialsStyle }, [t._v(" " + t._s(t.initials) + " ")])]) : t._e()], 2);
}, H = [], j = /* @__PURE__ */ L(
  P,
  T,
  H,
  !1,
  null,
  "7aacfcf3",
  null,
  null
);
const vt = j.exports;
export {
  vt as N,
  z as u
};
